import { useQuery } from "@tanstack/react-query";
import { Card } from "@rumbledirect/ui";
import { fetchLogs } from "../../../../lib/api/resources/logs";
import { Dossier } from "@rumble-it/common-lib/types/models/Dossier.interface";
import { Table } from "@/components/v2";
import { Log } from "@rumble-it/common-lib/types/models/Log.interface";
import { useState } from "react";
import { logColumns } from "../lib/constants/logColumns";

interface LogsCard {
  dossier?: Dossier;
}

export const LogsCard = ({ dossier }: LogsCard) => {
  const [page, setPage] = useState(1);

  const logsQuery = useQuery({
    queryKey: ["logs", dossier?.id, page],
    queryFn: async () => {
      if (!dossier?.id) {
        throw new Error("No dossier selected");
      }
      const logs = await fetchLogs({
        "usage[dossier]": dossier.id,
        page: page,
        itemsPerPage: 30,
      });
      return logs;
    },
    enabled: !!dossier?.id,
  });

  return (
    <Card title="Logboek" loading={logsQuery.isLoading}>
      <Table
        rowKey={(row) => (row as Log).id}
        columns={logColumns()}
        dataSource={logsQuery.data}
        loading={logsQuery.isLoading}
        size="small"
        pagination={{
          pageSize: 30,
          total: logsQuery.data?.totalItems,
          showSizeChanger: false,
          onChange: (page) => setPage(page),
        }}
      />
    </Card>
  );
};
